import { createAction, props } from "@ngrx/store";
import { IdTokenClaims, UserState } from "./state";

export const entry = createAction("[USER] ENTRY");
export const loginAttempt = createAction("[USER] LOGINATTEMPT");
export const loginSuccess = createAction(
    "[USER] LOGINSUCCESS",
    props<UserState>(),
);
export const loginFailure = createAction(
    "[USER] LOGINFAILURE",
    props<{ error: string }>(),
);
export const loginToken = createAction(
    "[USER] LOGINTOKEN",
    props<{
        id_token: string;
        access_token: string;
        idTokenClaims?: IdTokenClaims;
    }>(),
);

export const logoutAttempt = createAction("[USER] LOGOUTATTEMPT");
export const logoutSuccess = createAction("[USER] LOGOUTSUCCESS");
